import { useEffect } from 'react'

import type { TQueryDetails } from '@hozana/api/hooks/useApiData'
import { useIsRequestUpToDate } from '@hozana/api/hooks/useIsRequestUpToDate'

/**
 * While a page is statically generated, the request is fetched with no user: its user specific properties are not up to date.
 * We need to refetch it when the user is logged in to get the updated values of the specific properties.
 *
 * If `useUpdateRequest` is already executed somewere, `useIsRequestUpToDate` can be used to make sure
 * that the request is not refetched several times.
 */
export const useUpdateRequest = (queryDetails: TQueryDetails): boolean => {
  const { refetch, loading } = queryDetails
  const requestUpToDate = useIsRequestUpToDate(queryDetails.queryKey)

  useEffect(() => {
    if (!loading && !requestUpToDate) {
      refetch()
    }
  }, [loading, refetch, requestUpToDate])

  return requestUpToDate
}
